/* eslint-disable no-param-reassign */
import { ColorVals, ColorVariant, LogoVariant } from './types';
import { veeqoColors } from './colors';

export const getLogoProps = ({
  variant = 'full',
  colorVariant = 'white',
  iconColor,
  iconBackgroundColor,
  swishColor,
  textColor,
  style,
}: {
  iconColor?: ColorVals;
  iconBackgroundColor?: string;
  swishColor?: ColorVals;
  textColor?: ColorVals;
  variant?: LogoVariant;
  colorVariant?: ColorVariant;
  style?: React.CSSProperties;
}) => {
  let showIcon = false;
  let showVeeqo = false;
  let showAmazon = false;
  let viewport = '0 0 260 108';

  switch (variant) {
    case 'icon':
      showIcon = true;
      viewport = '0 0 56.6 55.6';
      break;
    case 'veeqo':
      showVeeqo = true;
      viewport = '69 0 192 60';
      break;

    case 'icon_veeqo':
      showIcon = true;
      showVeeqo = true;
      viewport = '0 0 260 60';
      break;

    case 'amazon':
      showAmazon = true;
      viewport = '0 75 260 33';
      break;
    case 'full':
    default:
      showIcon = true;
      showVeeqo = true;
      showAmazon = true;
      break;
  }

  switch (colorVariant) {
    case 'swish':
      iconColor = iconColor || veeqoColors.blue;
      iconBackgroundColor = iconBackgroundColor || veeqoColors.white;
      swishColor = swishColor || veeqoColors.orange;
      textColor = textColor || veeqoColors.white;
      break;
    case 'blue':
      iconColor = iconColor || veeqoColors.blue;
      iconBackgroundColor = iconBackgroundColor || veeqoColors.white;
      swishColor = swishColor || veeqoColors.white;
      textColor = textColor || veeqoColors.white;
      break;
    case 'black':
      iconColor = iconColor || veeqoColors.black;
      swishColor = swishColor || veeqoColors.black;
      iconBackgroundColor = iconBackgroundColor || veeqoColors.white;
      textColor = textColor || veeqoColors.black;
      break;
    case 'white':
    default:
      iconColor = iconColor || veeqoColors.white;
      iconBackgroundColor = iconBackgroundColor || veeqoColors.transparent;
      swishColor = swishColor || veeqoColors.white;
      textColor = textColor || veeqoColors.white;
      break;
  }

  return {
    viewport,
    showIcon,
    showVeeqo,
    showAmazon,
    iconColor: iconColor || veeqoColors.white,
    iconBackgroundColor: iconBackgroundColor || veeqoColors.transparent,
    swishColor: swishColor || veeqoColors.white,
    textColor: textColor || veeqoColors.white,
    style,
  };
};
